import { FC, ReactNode } from 'react';
import { differenceInDays, differenceInHours, parseISO } from 'date-fns';
import { Text } from '@qga/roo-ui/components';
import { CancellationWindow } from 'lib/graphql/generated';
import getRefundableText from '../utils/getRefundableText';

interface Props {
  cancellationWindow: CancellationWindow;
  checkInDateTime: string;
  showDaysCount: boolean;
  additionalInfo: string | ReactNode | undefined;
}

const RefundDescription: FC<Props> = ({ cancellationWindow, checkInDateTime, showDaysCount, additionalInfo }) => {
  const daysBeforeCheckIn = differenceInDays(parseISO(checkInDateTime), parseISO(cancellationWindow.startTime));
  const hoursBeforeCheckIn = differenceInHours(parseISO(checkInDateTime), parseISO(cancellationWindow.startTime));
  const timeToCheckInDescription =
    daysBeforeCheckIn > 0
      ? `${daysBeforeCheckIn} day${daysBeforeCheckIn === 1 ? '' : 's'} before check-in`
      : `${hoursBeforeCheckIn} hour${hoursBeforeCheckIn === 1 ? '' : 's'} before check-in`;
  return (
    <>
      {showDaysCount && <Text as="div">{timeToCheckInDescription}</Text>}
      {additionalInfo && <Text as="div">{additionalInfo}</Text>}
      <Text as="div">{getRefundableText(cancellationWindow.cancellationType)}</Text>
    </>
  );
};

export default RefundDescription;
